import React from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { getUserWarehouseLocations } from '../../common/store/locationsSlice';

export const UserLocationsLoadError = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const handleRetry = () => {
        dispatch(getUserWarehouseLocations());
    };

    return (
        <Alert
            severity="error"
            action={(
                <Button color="inherit" size="small" onClick={handleRetry}>
                    {t('error.user_locations_load_retry')}
                </Button>
            )}
        >
            {t('error.user_locations_load_failed')}
        </Alert>
    );
};
